// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

function saveOrderCustomForm(data) {

	const form = document.querySelector('#form_id-4769');
	form.querySelector("[name=operation]").value = "saveOrderCustomForm"
	const params = new FormData(form);

	fetch("/ajax/functions.php", {
		method: "POST",
		body: params
	})

}

(function () {

	let hash = document.URL.split("#")[1];
	if (hash) {
		if (hash == "gifts") {
			if (document.querySelector("ul[role=tablist] li[data-filter='gift-certificate']"))
				document.querySelector("ul[role=tablist] li[data-filter='gift-certificate']").click();
			if (document.querySelector("ul[role=tablist] li[data-filter='gifts']"))
				document.querySelector("ul[role=tablist] li[data-filter='gifts']").click();
		}

		setTimeout( () => {

			let activities = document.querySelectorAll(".activities-block__item--info h2")
			activities.forEach(function (activity) {
				let activity_name = activity.innerText
				console.log( decodeURIComponent(activity_name).toLowerCase().replaceAll( " ", "+" ) + " - " + (hash).toLowerCase() )
				if( decodeURIComponent(activity_name).toLowerCase().replaceAll( " ", "+" ) == (hash).toLowerCase() ){
					activity.parentNode.querySelector("a.btn-terms").click()
				}
			})

		} , 1500 )
	}

	let same_as_guest_one = document.querySelector("[name*=same_as_guest_one]")

	function replaceValueOnSecond(initial, second) {

		if (!document.querySelector(second) || !document.querySelector(initial)) return;

		document.querySelector(second).value = document.querySelector(initial).value
		document.querySelector(second).focus()
	}

	function emptyField(initial) {
		if (!document.querySelector(initial)) return;
		document.querySelector(initial).value = ""
	}

	if (same_as_guest_one) {

		let will_you_be_traveling_solo_or_with_guest_ = document.querySelector("[name=will_you_be_traveling_solo_or_with_guest_]")
		will_you_be_traveling_solo_or_with_guest_.addEventListener("change", (e) => {
			let value = e.target.value

			console.log(same_as_guest_one.parentNode.parentNode)

			if (value == "i_will_be_traveling_with_a_second_guest") {
				same_as_guest_one.parentNode.parentNode.classList.remove("hidden")
			} else {
				same_as_guest_one.parentNode.parentNode.classList.add("hidden")
			}

		})

		same_as_guest_one.parentNode.parentNode.classList.add("hidden")
		same_as_guest_one.parentNode.parentNode.querySelector(".form-module__field--label").classList.add("hidden")

		same_as_guest_one.addEventListener("change", (e) => {
			let target = e.target

			if (target.checked) {
				replaceValueOnSecond("[name=street]", "[name=guest_2_street]");
				replaceValueOnSecond("[name=city]", "[name=guest_2_city]");
				replaceValueOnSecond("[name=state___province]", "[name=guest_2_state___province]");
				replaceValueOnSecond("[name=country]", "[name=guest_2_country]");
				// replaceValueOnSecond( "[name=zip___postal_code]", "[name=guest_2_zip___postal_code]" );
				// replaceValueOnSecond( "[name=phone]", "[name=guest_2_phone]" );
				// replaceValueOnSecond( "[name=email_address]", "[name=guest_2_email]" );
				// replaceValueOnSecond( "[name=would_you_like_our_wellness_concierge_to_contact_you_about_our_wellness_program_]", "[name=would_guest_2_like_our_wellness_concierge_to_contact_you_about_our_wellness_program_]" );
				// replaceValueOnSecond( "[name=birthday]", "[name=guest_2_birthday]" );
				// replaceValueOnSecond( "[name=are_you_celebrating_a_special_occasion_]", "[name=is_guest_2_celebrating_a_special_occasion_]" );
			} else {
				emptyField("[name=guest_2_street]");
				emptyField("[name=guest_2_city]");
				emptyField("[name=guest_2_state___province]");
				emptyField("[name=guest_2_country]");
				// emptyField( "[name=guest_2_zip___postal_code]" );
				// emptyField( "[name=guest_2_phone]" );
				// emptyField( "[name=guest_2_email]" );
				// emptyField( "[name=would_guest_2_like_our_wellness_concierge_to_contact_you_about_our_wellness_program_]" );
				// emptyField( "[name=guest_2_birthday]" );
				// emptyField( "[name=is_guest_2_celebrating_a_special_occasion_]" );
			}
		})
	}

	// Forms subject
	if (document.querySelectorAll('.js-custom-subject').length > 0) {
		document.querySelectorAll('.js-custom-subject').forEach(customForm => {
			let form = customForm.querySelector('form');
			let formSubject = form.querySelector('input[name="subject"]').value;

			if (form.querySelector('input[name="_alt_subject"]') || form.querySelector('input[name="alt_subject"]')) {
				let altSubject = form.querySelector('input[name="_alt_subject"]') !== null ? form.querySelector('input[name="_alt_subject"]') : form.querySelector('input[name="alt_subject"]');
				altSubject.setAttribute('value', formSubject);
				altSubject.setAttribute('name', 'alt_subject');
				altSubject.value = formSubject;
			}
			form.querySelectorAll('input').forEach(input => {
				let inputName = input.getAttribute('name');
				
				if (inputName && inputName.includes('name') && !inputName.includes('form_name')) {
					input.addEventListener('blur', function () {
						let userName = '';
						form.querySelectorAll('input').forEach(i => {
							let iName = i.getAttribute('name');
							if (iName && iName.includes('name') && !iName.includes('form_name')) {
								userName += i.value + ' ';
							}
						});
						form.querySelector('input[name="subject"]').setAttribute('value',  formSubject + ' - ' + userName );
						form.querySelector('input[name="subject"]').value = formSubject + ' - ' + userName;

					})
				}
			})


		});
	}


	if (!(window.ActiveXObject) && "ActiveXObject" in window) {

		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for (let i = 0; i < image_fit.length; i++) {
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if (image_data) {
						image_fit[i].style.backgroundImage = 'url("' + image_data + '")';
					} else {
						image_fit[i].style.backgroundImage = 'url("' + image_src + '")';
					}

				}
			}
			else {
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 *****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if (formModule) {
		formModule.forEach(function (form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if (textModule) {
		textModule.forEach(function (text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	/* Remove empty <p> tags created by tinymce */
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//// Forms animation for labels   ----------------------------------------------------------------
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_first_name')) {
		document.getElementById('email-signup_first_name').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_last_name')) {
		document.getElementById('email-signup_last_name').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		// ---------------------------------------------------------------- GENERAL SITE'S FUNCTIONS ----------------------------------------------------------------
		let galleryContainer = document.querySelector('#gallery-flex #content');

		if (galleryContainer) {
			setTimeout(() => {
				galleryContainer.style.opacity = 1;
			}, 500);
		}

		if (document.getElementById('header').classList.contains('no-hero')) {
			document.getElementById('header').classList.add('scroll');
		} else {
			scrollW();
			window.addEventListener('scroll', function () {
				scrollW();
			})
		}

		// Main Nav Dropdown
		let primaryNav = document.getElementById('primary-nav');
		if (primaryNav) {
			primaryNav.querySelectorAll('li').forEach(function (primary_nav) {
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if (primary_nav.querySelector('ul.submenu')) {
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if (primary_nav.querySelector('ul.submenu')) {
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});

			// Parent <a> should be active if any submenu link is active
			function syncParentAnchors(primaryNav) {
				var submenus = primaryNav.querySelectorAll('ul.submenu');
				for (var i = 0; i < submenus.length; i++) {
					var ul = submenus[i];
					var activeChild = ul.querySelector('li > a.active');
					if (activeChild) {
						var parentLi = ul.parentNode;
						if (parentLi) {
							var parentA = parentLi.getElementsByTagName('a')[0];
							if (parentA && !parentA.classList.contains('active')) {
								parentA.classList.add('active');
							}
						}
					}
				}
			}

			syncParentAnchors(primaryNav);
			var childLinks = primaryNav.querySelectorAll('ul.submenu li > a');
			for (var j = 0; j < childLinks.length; j++) {
				childLinks[j].addEventListener('click', function () {
					var li = this.parentNode;
					var ul = li ? li.parentNode : null;
					var parentLi = ul ? ul.parentNode : null;
					if (parentLi) {
						var parentA = parentLi.getElementsByTagName('a')[0];
						if (parentA) parentA.classList.add('active');
					}
				});
			}
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if (secondaryNav) {
			secondaryNav.querySelectorAll('li').forEach(function (secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if (secondary_nav.querySelector('ul.submenu')) {
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if (secondary_nav.querySelector('ul.submenu')) {
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass: 'lbx-gallery',
		});

		// MENU HOMEPAGE ----------------------------------------------------------------
		if (document.querySelector('#home') != null) {
			let header = document.getElementById('header');
			let toggle = document.getElementById('navToggle');
			let nav = document.getElementById('siteNav');
			let logo = document.querySelector('.menu-cta__logo');
			if (!header || !toggle || !nav || !logo) return;


			function openNav() {
				nav.classList.add('open');
				toggle.setAttribute('aria-expanded', 'true');
				toggle.classList.add('inactive');
				logo.classList.remove('inactive');
			}

			function closeNav() {
				nav.classList.remove('open');
				toggle.setAttribute('aria-expanded', 'false');
				toggle.classList.remove('inactive');
				logo.classList.add('inactive');
			}

			function isOpen() {
				return nav.classList.contains('open');
			}

			toggle.addEventListener('click', function () {
				isOpen() ? closeNav() : openNav();
			});

			var mo = new MutationObserver(function () {
				if (header.classList.contains('scroll')) {
					openNav();
				} else {
					closeNav();
				}
			});
			mo.observe(header, { attributes: true, attributeFilter: ['class'] });

			if (header.classList.contains('scroll')) {
				openNav();
			} else {
				closeNav();
			}
		}

		// BURGUER MENU MOBILE ----------------------------------------------------------------
		const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
		const burgerMenuContainer = document.querySelector("#js-menuContainer")
		const closeMenu = document.querySelector(".js-burger-close");

		//Open Menu

		if (burgerMenuBtn) {
			burgerMenuBtn.addEventListener('click', function (e) {
				e.preventDefault();
				burgerMenuContainer.classList.add("open");
				document.body.classList.add("no-scroll");
			});
		}

		if (closeMenu) {
			closeMenu.addEventListener('click', () => {
				burgerMenuContainer.classList.remove("open");
				document.body.classList.remove("no-scroll");
			});
		}

		// SHOW SUBMENU FUNCTION: 

		const submenuToShow = (linksSelector, linkSubmenu) => {
			let navLinks = document.querySelectorAll(linksSelector);
			let submenu_active = document.querySelectorAll(linkSubmenu);

			navLinks.forEach(link => {
				const parent = link.parentNode;
				let submenu = parent.querySelector('.submenu');
				link.addEventListener('click', (e) => {
					document.querySelectorAll('.submenu.active').forEach(activeSubmenu => {
						activeSubmenu.classList.remove('active');
					});
					document.querySelectorAll(`${linksSelector}.active`).forEach(activeLink => {
						activeLink.classList.remove('active');
					});
					link.classList.toggle('active');
					submenu.classList.toggle('active');
				});
			});
			submenu_active.forEach(sub => {
				if (sub.classList.contains('active')) {
					if (window.screen.width > 640) {
						let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					} else {
						let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}
				}

			})
		}

		if (window.screen.width > 640) {
			submenuToShow('#primary-nav li a', '.submenu li a');
		} else {
			submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
		}


		const navItems = document.querySelectorAll('.privary-navigation__item');
		const navItemsMob = document.querySelectorAll('.mobileMenu__nav li');

		function addNoSubmenuClass() {
			navItems.forEach(item => {

				const submenu = item.querySelector('.privary-navigation__submenu');
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});
		}

		function addNoSubmenuMobileClass() {
			navItemsMob.forEach(item => {

				const submenu = item.querySelector('.sub-sub-menu');


				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});
		}

		if (window.screen.width > 768) {
			addNoSubmenuClass();
		} else {
			addNoSubmenuMobileClass()
		}

		// Links to scroll
		document.querySelectorAll('a').forEach(anchor => {
			if (anchor.getAttribute('href') != null) {
				if (anchor.getAttribute('href').startsWith('#')) {
					anchor.addEventListener('click', function (e) {
						let currentTarget = anchor.getAttribute('href');

						if (document.querySelector(currentTarget)) {
							e.preventDefault();
							document.querySelector(currentTarget).scrollIntoView({ behavior: 'smooth' });
						}
					});
				}
			}
		});

		// Scroll to calendar apppunch
		let url_link = window.location.href;
		let url_hash = url_link.split('#')[1];

		if (url_hash && url_hash === 'apppunch') {
			let calendar = document.getElementById('apppunch');
			setTimeout(() => calendar.scrollIntoView({ behavior: 'smooth' }), 2200);
		}
	});

	animateto();

	// ---------------------------------------------------------------- INDIVIDUAL SITE'S FUNCTIONS ----------------------------------------------------------------

	let numbers = document.querySelectorAll('.pins .number');

	if (numbers) {
		numbers.forEach(number => {
			if (window.innerWidth >= 1024) {
				number.addEventListener('mouseenter', () => {
					document.querySelectorAll('.pins .pin').forEach(pin => {
						pin.classList.remove('active');
					});

					const pin = number.nextElementSibling;
					if (pin && pin.classList.contains('pin')) {
						pin.classList.add('active');
					}
				});

				number.addEventListener('mouseleave', () => {
					const pin = number.nextElementSibling;
					if (pin && pin.classList.contains('pin')) {
						pin.classList.remove('active');
					}
				});
			}
			else {
				number.addEventListener('click', () => {
					document.querySelectorAll('.pins .pin').forEach(pin => {
						pin.classList.remove('active');
					});

					const pin = number.nextElementSibling;
					if (pin && pin.classList.contains('pin')) {
						pin.classList.add('active');
					}
				});
			}
		});
	}

	// Submenu mobile turn into Select ************************************
	function isMobile() {
		return window.innerWidth <= 640;
	}

	function convertSubmenuToSelect() {
		const submenu = document.querySelector('.sub-menu__hold .sub-menu ul');
		if (!submenu) return;

		const select = document.createElement('select');
		select.setAttribute('aria-label', 'Section Navigation');

		submenu.querySelectorAll('li').forEach((li) => {
			const link = li.querySelector('a');
			const option = document.createElement('option');
			option.value = link.href;
			option.textContent = link.textContent.trim();

			if (link.classList.contains('active')) {
				option.selected = true;
			}

			select.appendChild(option);
		});

		select.addEventListener('change', (event) => {
			const selectedUrl = event.target.value;
			if (selectedUrl) {
				window.location.href = selectedUrl;
			}
		});

		submenu.parentNode.replaceChild(select, submenu);
	}

	if (isMobile()) {
		convertSubmenuToSelect();
	}

	const introContent = document.querySelector('#intro-content');
	if (introContent) {
		if (introContent && introContent.querySelector('.sub-menu__hold .sub-menu')) {
			introContent.classList.add('with-submenu');
		} else {
			introContent.classList.remove('with-submenu');
		}
	}

	function toggleFixedSubmenuOnScroll() {
		const header = document.getElementById('header');
		const subMenuHold = document.querySelector('.sub-menu__hold');

		if (!header || !subMenuHold) return;
		const initialSubMenuHoldTop = subMenuHold.getBoundingClientRect().top + window.scrollY;

		window.addEventListener('scroll', () => {
			const headerBottom = header.getBoundingClientRect().bottom + window.scrollY;
			if (headerBottom >= initialSubMenuHoldTop) {
				subMenuHold.style.position = 'fixed';
				subMenuHold.style.top = '80px';
			} else if (window.scrollY < initialSubMenuHoldTop) {
				subMenuHold.style.position = 'absolute';
				subMenuHold.style.top = '0px';
			}
		});
	}

	toggleFixedSubmenuOnScroll();

	if (document.getElementById('language')) {
		document.getElementById('language').addEventListener("change", function (e) {
			changeLanguage(e.target.value);
		});
	}

	const logoImage = document.querySelector('#resumator-logo  img');
	if (logoImage) {
		logoImage.setAttribute('alt', 'Powered by jazzhr');
	}

	// Search FAQ's
	const SEARCH_BAR = document.getElementById('search_faq');
	let allSearchItems = document.querySelectorAll('.js-accordion-item');

	if (SEARCH_BAR && allSearchItems) {
		SEARCH_BAR.addEventListener('keyup', e => {
			allSearchItems.forEach(entry => {
				let currentTitle = entry.querySelector('.js-accordion-title').textContent;

				if (currentTitle.toLowerCase().includes(SEARCH_BAR.value.toLowerCase())) {
					entry.classList.remove('hidden');
				} else {
					entry.classList.add('hidden');
				}
			})
		});
	}

	// Set content to meta viewport
	const metaViewport = document.querySelector('meta[name="viewport"]');

	if (metaViewport) {
		metaViewport.setAttribute('content', 'width=device-width, initial-scale=1.0, interactive-widget=resizes-content');
	}

	//open search input
	const searchBtn = document.querySelector('header #search--btn');
	const searchForm = document.querySelector('header #search--form');

	if(searchBtn && searchForm){
		searchBtn.addEventListener('click', (e)=>{
			if(searchForm.classList.contains('active')){
				searchForm.submit();
			}else{
				searchForm.classList.add('active');
			}
		})
	}


	if(document.querySelector('.special-text-form ')) {
		let formTextFoster = document.querySelector('.special-text-form ');
		formTextFoster = formTextFoster.parentElement;
		let contentFormFoster = document.querySelector('.special-text');
		contentFormFoster.appendChild(formTextFoster);
	}

})();

function animateto() {
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();
			const targetId = this.getAttribute('href').substring(1);

			if (targetId && document.getElementById(targetId) && !this.classList.contains('no-scroll-animation')) {
				scrollToTarget(targetId);
			}
		});
	});

	if (location.hash) {
		const targetId = location.hash.substring(1);
		if (document.getElementById(targetId)) {
			setTimeout(() => scrollToTarget(targetId), 100);
		}
	}

	function scrollToTarget(target) {
		var gotoTarget = offset(document.getElementById(target)).top - 230;
		var from = window.pageYOffset;
		var to = gotoTarget;
		var duration = 1300;
		var start = new Date().getTime();

		var timer = setInterval(function () {
			var time = new Date().getTime() - start;
			var y = (from <= to)
				? easeInOutQuart(time, from, to - from, duration)
				: easeInOutQuart(time, from, -(from - to), duration);

			window.scrollTo(0, y);
			if (time >= duration) clearInterval(timer);
		}, 1000 / 60);
	}
}

// Download PDF from Media kit form
function downloadPDF(form) {
	switch (form[9].value) {
		case 'media_kit_short_summary_2025':
			window.open('https://symphony.cdn.tambourine.com/bucuti-tara-beach-resort/media/media-kit-short-summary-2025-68fa973b4cfd6.pdf', '_blank').focus();
			break;
		case 'marketing_kit_2025':
			window.open('https://symphony.cdn.tambourine.com/bucuti-tara-beach-resort/media/marketing-kit-2025-68fa973d43d17.pdf', '_blank').focus();
			break;
		default:
			window.open('https://symphony.cdn.tambourine.com/bucuti-tara-beach-resort/media/media-kit-short-summary-2025-68fa973b4cfd6.pdf', '_blank').focus();
			break;
	}
}

/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW() {
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		// downscroll code
		if (!document.getElementById('header').classList.contains('scroll')) {
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');
		}
	} else {
		if (document.getElementById('header').classList.contains('scroll')) {
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}